export default {
  common: {
    login: "Connexion",
    userName: "Nom d'utilisateur",
    password: "Mot de passe",
    rememberPassword: "Se souvenir de moi",
    modifyPassword: "Modifier le mot de passe",
    accountRegister: "Inscription du compte",
    pleaseInput: "Veuillez saisir",
    loginErrorCheckNamePassword: "Échec de la connexion, veuillez vérifier le nom d'utilisateur et le mot de passe",
    guest: "Invité",
    superAdmin: "Super administrateur",
    logOut: "Se déconnecter",
    inputUserName: "Entrer le nom d'utilisateur",
    inputPassword: "Entrer le mot de passe",
    modifySuccessfully: "Modifier le mot de passe avec succès!",

    using: "Utilisation",
    toLogin: "pour se connecter",
    noOktaLoginUrl: "Aucune URL de connexion OKTA",
    uncheckSwitch: "Décochez cette case pour passer au mode de connexion régulier",

    noADLoginUrl: "Aucune URL de connexion Azure AD"
  },
  register: {
    email: "Adresse e-mail",
    confirmPassword: "Confirmer le mot de passe",
    register: "S'inscrire",
    emailRequire: "L'e-mail est requis",
    passwordRequire: "Le mot de passe est requis",
    confirmPasswordRequire: "La confirmation du mot de passe est requise",
    passwordInconsistency: "Incohérence du mot de passe",
    registeredSuccessfully: "Inscription réussie !",
    jumpToLoginPage: "Le système vous redirigera automatiquement vers la page de connexion.",
    contactAdminActivate: "Veuillez contacter votre administrateur pour activer votre compte avant de vous connecter.",
    USER_EXISTS: "Cet utilisateur existe déjà",

    emailExists: "L'e-mail existe déjà",
    emailInconsistency: "Incohérence des e-mails",
    confirmEmailAddress: "Confirmer l'adresse e-mail",
    emailAgain: "Entrez votre e-mail à nouveau",
    approvedCarrierOnly: "Réservé aux employés Carrier autorisés."
  },
  my: {
    about: "À propos",
    language: "Langue",
    nomenclatureList: "Liste de nomenclature",

    appName: "Nom de l'application",
    version: "version",
    iecmFF: "iECM Cadre fonctionnel",
    paragraph1:
      "1. Les méthodes d'estimation de base sont pleinement conformes au Protocole international de mesure et de vérification de la performance (IPMVP) et chaque méthode est conforme aux lignes directrices de l'IPMVP pour assurer une évaluation crédible et transparente de la performance énergétique.",
    paragraph2: "2. La bibliothèque actuelle utilise des courbes de performance basées sur les conditions AHRI.",
    paragraph3: "3. Les entrées de performances e-CAT certifiées AHRI pour un refroidisseur post-retrofit sont autorisées.",

    learningCenter: "Centre d'apprentissage",
    learningCenterDescription: "Accédez à des vidéos tutoriels, des manuels d'utilisateur et des guides de flux de travail pour vous aider à utiliser iECM plus efficacement."
  }
}



// WEBPACK FOOTER //
// ./src/locale/login/fr.js